import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import React, { useState, useEffect } from "react";
import StepContent from "./StepContent";
import { StyledFormTitle } from "../IntegrationWidgetSetting.styles";
import Button, { VARIANT } from "@metacrm/metacrm-material-ui/dist/Button";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { Box } from "@mui/material";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import axios from "axios";
import { Spinner, COLOR } from "@metacrm/metacrm-material-ui/dist/Spinner";
import { useIntl } from "react-intl";
import { formatCalendarDateAndTime } from "features/helpers/utils";

export default function RunTest({
  needInstallId,
  installationId,
  apiPath,
  title,
  description,
  label,
}) {
  const { formatMessage } = useIntl();

  const [entityName] = useOutletContext();
  const dispatchSnackbar = useDispatchSnackbar();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [lastRunTestTime, setLastRunTestTime] = useState(null);

  useEffect(() => {
    if (needInstallId && !installationId) return;
    handleCheckInstallStatus();
  }, [needInstallId, installationId]);

  const handleCheckInstallStatus = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${apiUrl}/api/manage/${apiPath}/${entityName}`
      );

      const connectStatus = needInstallId
        ? // data is an array
          data.find((configItem) => configItem._id === installationId)
            ?.connected
        : // data is an object
          data?.connected;

      setLastRunTestTime(new Date());
      setStatus(connectStatus);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setLoading(false);
    }
  };

  const renderStatusIcon = () => {
    if (loading) {
      return (
        <>
          <Spinner
            size={14}
            style={{ marginRight: "4px" }}
            color={COLOR.SECONDARY}
          />
          {formatMessage({ id: "global.status.checking" })}
        </>
      );
    }
    if (status) {
      return (
        <>
          <i
            className="meta-crm-icon-ic_check font-size-16"
            style={{ marginRight: "4px" }}
          />
          {formatMessage({ id: "global.status.successful" })}
        </>
      );
    }
    return (
      <>
        <i
          className="meta-crm-icon-ic_cancel font-size-16"
          style={{ marginRight: "4px" }}
        />
        {formatMessage({ id: "global.status.failed" })}
      </>
    );
  };

  const runTestBlock = {
    title,
    describe: description,
    content: (
      <>
        <StyledFormTitle center item xs={12} md={4}>
          <Button variant={VARIANT.OUTLINED} onClick={handleCheckInstallStatus}>
            {formatMessage({ id: "global.btn.runTest" })}
          </Button>
        </StyledFormTitle>
        <Grid position={"relative"} item xs={12} md={8}>
          <Box
            bgcolor="#FAFAFD"
            p="10px 12px"
            display="flex"
            alignItems="center"
            fontSize="14px"
          >
            <Box sx={{ color: "#777" }}>{label}</Box>
            <Box
              sx={{
                ml: "16px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                color: loading ? "#7B61FF" : status ? "#7B61FF" : "#FC5555",
              }}
            >
              {renderStatusIcon()}
            </Box>
          </Box>
          <Box sx={{ display: "flex", position: "absolute", marginTop: "8px" }}>
            <Box
              color={(theme) => theme.customColors.grey[600]}
              size="12px"
              mr="2.5px"
            >
              {formatMessage({
                id: "notification.subscribeBtn.installChecktime",
              })}{" "}
              :
            </Box>
            <Box color={(theme) => theme.customColors.purple[500]} size="12px">
              {formatCalendarDateAndTime(lastRunTestTime)}
            </Box>
          </Box>
        </Grid>
      </>
    ),
  };

  return (
    <StyledWhiteContainer style={{ marginBottom: "12px" }}>
      <StepContent settingStep={runTestBlock} />
    </StyledWhiteContainer>
  );
}
